import React from 'react';
import { FaTwitter } from '@react-icons/all-files/fa/FaTwitter';
import { FaInstagram } from '@react-icons/all-files/fa/FaInstagram';
import { FaFacebook } from '@react-icons/all-files/fa/FaFacebook';
import { FaWhatsapp } from '@react-icons/all-files/fa/FaWhatsapp';

const socialLinks = [
  {
    href: 'https://twitter.com/baws_bot',
    icon: FaTwitter,
    label: 'Twitter',
  },
  {
    href: 'https://www.instagram.com/baws_bot',
    icon: FaInstagram,
    label: 'Instagram',
  },
  {
    href: 'https://www.facebook.com/babasahebs.writings',
    icon: FaFacebook,
    label: 'Facebook',
  },
  {
    href: 'https://whatsapp.com/channel/0029Va4u5KhJ3jv7HAqyjy13',
    icon: FaWhatsapp,
    label: 'WhatsApp',
  },
];

const Footer = () => {
  return (
    <footer className="bg-white mt-12 py-8 border-t border-gray-200">
      <div className="container mx-auto px-4 text-center text-gray-600">
        <div className="flex justify-center space-x-6 mb-4">
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Follow us on ${link.label}`}
              className="text-gray-500 hover:text-indigo-600 transition-colors duration-300"
            >
              <link.icon className="h-6 w-6" />
            </a>
          ))}
        </div>
        <p className="text-sm">
          &copy; {new Date().getFullYear()} Ambedkar International Center, USA.
          All Rights Reserved.
        </p>
        <p className="text-xs mt-2">
          A project initiated and driven by volunteers.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
